export class ImageScaleFactorModel {
  '1x': string;
  '2x': string;
  '3x': string;

  constructor(img1x = '', img2x = undefined, img3x = undefined) {
    this['1x'] = img1x;
    this['2x'] = img2x || img1x;
    this['3x'] = img3x || img1x;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/images/image-scale-factor-model.ts